<template>
  <div id="app">
    <div v-if="isDevMode">
      {{ filter }}
    </div>
    <Breadcrumbs ref="breadcrumbs"/>
    <div ref="app">
      <router-view />
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/ui/Breadcrumbs.vue';
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name: 'App',
  components: {
    Breadcrumbs,
  },
  data() {
    return {
      height: 'auto',
    };
  },
  mounted() {
    this.checkIsMobile();
    window.addEventListener('resize', this.checkIsMobile);
    this.position();
    window.addEventListener('resize', this.position);
  },
  computed: {
    ...mapState(['steps', 'isDevMode', 'isMobile', 'currentQuestionId']),
    ...mapGetters(['filter']),
  },
  methods: {
    ...mapActions(['setIsMobile', 'setContainerHeight']),

    checkIsMobile() {
      const width = window.innerWidth;
      this.setIsMobile(width < 576);
    },
    position() {
      // @TODO: rework setting of inner container size
      if (!this.isMobile) {
        const wHeight = window.innerHeight;
        const top = this.offsetTop(this.$refs.app);
        let h = wHeight - top - 81;
        if (h < 500) {
          h = 500;
        }
        this.height = `${h}px`;
      }
      this.setContainerHeight(this.height);
    },

    offsetTop(el) {
      const rect = el.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      return rect.top + scrollTop;
    },
  },
  watch: {
    currentQuestionId() {
      if (this.isMobile) {
        this.$refs.breadcrumbs.$el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    },
  },
};
</script>

<style lang="scss">
body{
  padding: 0;
  margin: 0;
  font-family: 'Roboto', sans-serif;
}
#app {
  max-width: 1140px;
  margin: 0;
  padding: 0;
}
.header{
  padding: 0 50px;
  height: 165px;
  background-color: #999B9E;
  color: #FFF;
  font-size: 40px;
  line-height: 165px;
}

.header-text{
  line-height: 1.2;
  font-weight: 500;
}
.view-selector{
  padding: 10px;
  text-align: right;
  border-bottom: 1px solid #6c757d;
}
</style>
